import { buttonSize } from './configs/button-size.config';
import { buttonColor } from './configs/button-color.config';

export class ButtonClasses {
  buttonSize: string = buttonSize.default.class;
  buttonColor: string = buttonColor.default.class;
  userClass = '';

  set setSize(size: string) {
    this.buttonSize = size;
  }

  set setColor(color: string) {
    this.buttonColor = color;
  }

  set setUserClass(styleClass: string) {
    this.userClass = styleClass;
  }
}
